/**Api google dirve */
import axios from 'axios';


export default axios.create({
    baseURL: 'https://us-central1-dialogflow.googleapis.com',
    method: 'post',
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type' : 'application/json;charset=utf-8'
    }
});
